import { ContentMetadata, MediaType } from '@/lib/model';
import { cn } from '@/lib/utils';
import {
  isAudioContentMetadataType,
  isVideoContentMetadataType,
} from '@/utils/contentType/contentType';

interface Props {
  mobileContentMetadata?: ContentMetadata;
  desktopContentMetadata?: ContentMetadata;
  containerClassName?: string;
  dataTestId?: string;
  articleContent?: React.ReactNode;
  videoContent?: React.ReactNode;
  audioContent?: React.ReactNode;
}

export function getPlatformContentType(
  contentMetadata: ContentMetadata,
): MediaType {
  return contentMetadata?.tvShow?.id ||
    isVideoContentMetadataType(contentMetadata)
    ? 'VIDEO'
    : isAudioContentMetadataType(contentMetadata)
      ? 'AUDIO'
      : 'ARTICLE';
}

const PlatformContentRender = ({
  articleContent,
  videoContent,
  audioContent,
  contentType,
}: {
  contentType: MediaType;
} & Pick<Props, 'articleContent' | 'videoContent' | 'audioContent'>) => {
  if (contentType === 'VIDEO' && videoContent) {
    return videoContent;
  } else if (contentType === 'AUDIO' && audioContent) {
    return audioContent;
  } else {
    return articleContent;
  }
};

export function PlatformContent({
  mobileContentMetadata,
  desktopContentMetadata,
  containerClassName,
  dataTestId,
  ...rest
}: Props) {
  const mobileType = getPlatformContentType(
    mobileContentMetadata as ContentMetadata,
  );

  const desktopType = getPlatformContentType(
    desktopContentMetadata as ContentMetadata,
  );

  if (mobileType === desktopType) {
    return (
      <div data-testid={dataTestId} className={cn(containerClassName)}>
        <PlatformContentRender {...rest} contentType={mobileType} />
      </div>
    );
  }

  return (
    <>
      <div
        className={cn('block lg:hidden', containerClassName)}
        data-testid={dataTestId}
      >
        <PlatformContentRender {...rest} contentType={mobileType} />
      </div>
      <div
        className={cn('hidden lg:block', containerClassName)}
        data-testid={dataTestId}
      >
        <PlatformContentRender {...rest} contentType={desktopType} />
      </div>
    </>
  );
}
